import React from "react";

import "./Logo.scss";

export type SymbolProps = {
  cx?: string;
};

export const Symbol: React.FC<SymbolProps> = ({ cx = "" }) => {
  return (
    <svg
      className={`Symbol ${cx}`}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#111" />
      <circle cx="15" cy="15" r="14.5" stroke="#111" strokeOpacity=".8" />
      <path
        d="M15 15.126a4.126 4.126 0 1 1-8.252 0 4.126 4.126 0 0 1 8.251 0z"
        fill="#fff"
      />
      <circle cx="10.872" cy="15.564" fill="#111" r="1.954" className={"eye"} />
      <path
        d="M23.251 15.126a4.126 4.126 0 1 1-8.251 0 4.126 4.126 0 0 1 8.251 0z"
        fill="#fff"
      />
      <circle cx="19.124" cy="15.56" r="1.954" fill="#111" className={"eye"} />
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(40 7)" d="M0 0h73.28v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
